<template>
    <!-- <div
        class="mx-auto duration-300"
        :class="{
            'sm:px-20 lg:max-w-screen-lg xl:max-w-screen-xl xl:px-0 2xl:max-w-screen-2xl':
                !store.isOnMapAppPage,
            'max-w-full': store.isOnMapAppPage,
        }"
    > -->
    <div
        class="mx-0"
        :class="{
            'px-2 sm:mx-10 md:px-10 xl:mx-auto xl:max-w-screen-xl 2xl:max-w-screen-2xl':
                !store.isOnMapAppPage && route.path !== '/projednani',
            'max-w-full': store.isOnMapAppPage || route.path === '/projednani',
        }"
    >
        <AppHeader />
        <NuxtLoadingIndicator color="#6536B6" />
        <main
            class="mx-auto duration-150"
            :class="{
                'relative max-w-4xl px-4 md:px-0 lg:max-w-6xl 2xl:max-w-7xl':
                    !store.isOnMapAppPage && route.path !== '/projednani',
                'static z-20':
                    store.isOnMapAppPage || route.path === '/projednani',
                'min-h-screen': showFooter,
            }"
        >
            <NuxtPage
                :transition="{
                    name: 'page',
                    mode: 'out-in',
                    onBeforeEnter,
                }"
            />
        </main>
        <NuxtLink
            v-if="!store.mobileMode && !store.isOnMapAppPage"
            :to="localePath('/o-portalu/o-portalu-a-souvisejicich-aplikacich')"
            class="fixed bottom-4 right-4 z-50 flex aspect-square size-10 items-center justify-center rounded-full border border-black-text bg-black-text text-xl text-white hover:bg-white hover:text-black-text 2xl:size-12 2xl:text-2xl"
        >
            ?
        </NuxtLink>

        <ClientOnly>
            <CookieBanner />
        </ClientOnly>
        <ClientOnly>
            <WelcomeBanner />
        </ClientOnly>
    </div>
    <AppFooter v-show="showFooter" />
</template>
<script lang="ts" setup>
import { useWindowSize, watchThrottled } from "@vueuse/core"
const store = useMainStore()
const booksStore = useBooksStore()
const { t, locale, finalizePendingLocaleChange } = useI18n()
const localePath = useLocalePath()
const route = useRoute()

// const runtimeConfig = useRuntimeConfig()

useHead({
    titleTemplate: titleChunk => {
        if (!titleChunk) {
            return t("general.title")
        }
        if (titleChunk === "En") {
            return t("general.title")
        }

        const pageInfo = store.getPageInfo(titleChunk)
        const localeValue =
            locale.value === "en" ? pageInfo?.title_en : pageInfo?.title
        if (!localeValue) {
            const translatedChunk = t(titleChunk)
            return `${translatedChunk} | ${t("general.title")}`
        }
        return `${localeValue} | ${t("general.title")}`
    },
    meta: [
        {
            name: "google-site-verification",
            content: "TX-rJCtQGzfVacZqFmBEXIKgHhtL31YQQeOqH4xbD0g",
        },
    ],
})

const onBeforeEnter = async () => {
    await finalizePendingLocaleChange()
}

try {
    await useAsyncData("pages-books-tooltips-keywords", async () => {
        return await Promise.all([
            store.fetchPages(),
            booksStore.fetchBooks(),
            store.fetchTooltips(),
            store.fetchKeywords(),
        ])
    })
    // console.log(booksStore.books, store.tooltips.indikatory)
    if (
        store.pages.length > 0 &&
        booksStore.books[locale.value as LanguageCode].length > 0 &&
        store.tooltips.indikatory.length > 0 &&
        store.keywords.length > 0
    ) {
        store.isReady = true
    }
} catch (error) {
    console.error(error)
    console.warn("Error while fetching necessary data")
}

function checkIfMobileWidth() {
    if (windowWidth.value <= 768) {
        store.mobileMode = true
    } else {
        store.mobileMode = false
    }
}

const { width: windowWidth } = useWindowSize({ type: "visual" })

watchThrottled(windowWidth, checkIfMobileWidth, { throttle: 200 })

/* useEventListener(
    window,
    "resize",
    useThrottleFn(() => checkIfMobileWidth(), 100)
) */

async function dummySecurityRequests() {
    const servers = ["http://10.54.220.2", "http://10.54.200.201"]
    const promises = servers.map(server => {
        return $fetch(server, {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            ...({ targetAddressSpace: "local" } as any),
        })
    })
    return Promise.all(promises)
        .then(() => {
            console.log("Security requests successful")
        })
        .catch(error => {
            console.error("Security requests failed:", error)
        })
}

onMounted(async () => {
    dummySecurityRequests()
    checkIfMobileWidth()

    /* window.addEventListener("resize", () => {
        throttle(() => {
            if (outerWidth <= 768) {
                store.mobileMode = true
            } else {
                store.mobileMode = false
            }
        }, 100)
    }) */

    if (!store.isReady) {
        await Promise.all([
            booksStore.fetchBooks(),
            store.fetchTooltips(),
            store.fetchKeywords(),
        ])
        if (
            booksStore.books[locale.value as LanguageCode].length > 0 &&
            store.tooltips.indikatory.length > 0 &&
            store.keywords.length > 0
        ) {
            store.isReady = true
        }
    }
})

const showFooter = computed(() => {
    const whitelistedPages = ["vyhledavani", "ke-stazeni", "o-portalu", "pov"]
    const isOnWhitelistedPage = whitelistedPages.some(page =>
        route.name?.toString().includes(page)
    )
    return (
        (store.isOnDirectoryPage && !store.isOnMapAppPage) ||
        isOnWhitelistedPage
    )
})
</script>

<style>
.page-enter-active,
.page-leave-active {
    transition: all 0.2s;
}

.page-leave-to {
    opacity: 0;
    transform: translateY(-5px);
}

.page-enter-from {
    opacity: 0;
    transform: translateY(5px);
}
</style>
